import { ETraitsTypes } from 'Shared/types';
export const SIGNIFICANT_INDICATORS_INIT = {
    [ETraitsTypes.Binary]: 0,
    [ETraitsTypes.Continuous]: 0,
};
